'use client';

import { Helmet } from 'react-helmet-async';
import ContactUsClient from './ContactUsClient';

export default function ContactUsPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us</title>
        <meta
          name="description"
          content="Let's discuss how we can help your organization align strategy, people, and performance."
        />
      </Helmet>
      <ContactUsClient />
    </>
  );
}
